<template>
  <div class="page-wrapper">
   

    <div class="page-content" style="margin-top: -80px;">
      <AppBreadcrumb :items="[{ label: $t('realExam.breadcrumb') }]" />

      <!-- Loading state -->
      <div v-if="loading" class="loading-container">
        <a-spin size="large" />
        <p>{{ $t('realExam.loading') }}</p>
      </div>

      <!-- Error state -->
      <a-alert
        v-else-if="error"
        type="error"
        :message="error"
        show-icon
        class="error-alert"
      />

      <!-- Start button -->
      <template v-else-if="!started">
        <a-card class="custom-card">
          <p style="color: var(--text-soft); font-size: 15px;">
            {{ $t('realExam.startText') }}
          </p>
          <a-button type="primary" size="large" @click="startExam" :loading="starting">
            Boshlash
          </a-button>
        </a-card>
      </template>

      <!-- Exam room -->
      <template v-else>
        <RealExamRoom
          :title="title"
          :questions="questions"
          :result-id="resultId"
          back-route="/real-exam"
          @finish="handleExamFinish"
        />
      </template>
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '../components/AppBreadcrumb.vue'
import RealExamRoom from '../components/RealExamRoom.vue'
import { message } from 'ant-design-vue'
import api, { MEDIA_BASE_URL } from '@/api/axios'

export default {
  name: 'RealExamView',
  components: {
    AppBreadcrumb,
    RealExamRoom
  },
  data() {
    return {
      started: false,
      loading: false,
      starting: false,
      error: null,
      title: this.$t('realExam.title'),
      questions: [],
      resultId: null
    }
  },
  methods: {
    async startExam() {
      this.starting = true
      this.error = null

      try {
        const response = await api.post(
          `/v1/tests/start-random/`,
          { count: 20 }
        )

        if (response.data) {
          this.questions = response.data.questions
          this.resultId = response.data.result.id
          this.started = true
          message.success(this.$t('realExam.started'))
        }
      } catch (err) {
        console.error('Exam start error:', err)
        this.error = err.response?.data?.detail || this.$t('realExam.startError')
        message.error(this.error)
      } finally {
        this.starting = false
      }
    },

    handleExamFinish(result) {
      console.log('Exam finished:', result)
      // Router allaqachon RealExamRoom ichida /result ga yo'naltiriladi
    }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  gap: 16px;
}

.loading-container p {
  color: var(--text-soft);
  font-size: 14px;
}

.error-alert {
  margin-bottom: 20px;
}
</style>